"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsuranceIntegrationAction = exports.VISANA_MEDIDOSSIER_INSURANCE_IDS = exports.InsuranceId = exports.InsuranceIntegrationResponseErrorMessage = exports.DataTransferStatus = exports.MediplusStatus = exports.InsuranceCompany = exports.InsuranceIntegrationResponseStatus = void 0;
var InsuranceIntegrationResponseStatus;
(function (InsuranceIntegrationResponseStatus) {
    InsuranceIntegrationResponseStatus["Success"] = "Success";
    InsuranceIntegrationResponseStatus["AlreadyConnected"] = "AlreadyConnected";
    InsuranceIntegrationResponseStatus["Error"] = "Error";
})(InsuranceIntegrationResponseStatus || (exports.InsuranceIntegrationResponseStatus = InsuranceIntegrationResponseStatus = {}));
var InsuranceCompany;
(function (InsuranceCompany) {
    InsuranceCompany["kpt"] = "kpt";
    InsuranceCompany["visana"] = "visana";
    InsuranceCompany["helsana"] = "helsana";
    InsuranceCompany["css"] = "css";
    InsuranceCompany["okk"] = "okk";
    InsuranceCompany["swica"] = "swica";
    InsuranceCompany["atupri"] = "atupri";
})(InsuranceCompany || (exports.InsuranceCompany = InsuranceCompany = {}));
var MediplusStatus;
(function (MediplusStatus) {
    MediplusStatus["active"] = "active";
    MediplusStatus["deactivated"] = "deactivated";
})(MediplusStatus || (exports.MediplusStatus = MediplusStatus = {}));
var DataTransferStatus;
(function (DataTransferStatus) {
    DataTransferStatus["initializing"] = "initializing";
    DataTransferStatus["pendingImport"] = "pending_import";
    DataTransferStatus["active"] = "active";
    DataTransferStatus["deactivated"] = "deactivated";
})(DataTransferStatus || (exports.DataTransferStatus = DataTransferStatus = {}));
var InsuranceIntegrationResponseErrorMessage;
(function (InsuranceIntegrationResponseErrorMessage) {
    InsuranceIntegrationResponseErrorMessage["InvalidTan"] = "invalid_tan";
    InsuranceIntegrationResponseErrorMessage["Generic"] = "generic_error";
})(InsuranceIntegrationResponseErrorMessage || (exports.InsuranceIntegrationResponseErrorMessage = InsuranceIntegrationResponseErrorMessage = {}));
var InsuranceId;
(function (InsuranceId) {
    InsuranceId[InsuranceId["Visana"] = '1555'] = "Visana";
    InsuranceId[InsuranceId["Helsana"] = '1562'] = "Helsana";
    InsuranceId[InsuranceId["Css"] = '0008'] = "Css";
    InsuranceId[InsuranceId["Kpt"] = '0376'] = "Kpt";
    InsuranceId[InsuranceId["Okk"] = '455'] = "Okk";
    InsuranceId[InsuranceId["Swica"] = '1384'] = "Swica";
    InsuranceId[InsuranceId["Atupri"] = '0312'] = "Atupri";
})(InsuranceId || (exports.InsuranceId = InsuranceId = {}));
exports.VISANA_MEDIDOSSIER_INSURANCE_IDS = [
    String(InsuranceId.Visana),
    '1386',
    '1568',
    '1570',
];
var InsuranceIntegrationAction;
(function (InsuranceIntegrationAction) {
    InsuranceIntegrationAction["ConnectMediPlus"] = "connectmediplus";
})(InsuranceIntegrationAction || (exports.InsuranceIntegrationAction = InsuranceIntegrationAction = {}));
//# sourceMappingURL=mediplus.js.map